import FileAnalysisStore from 'stores/FileAnalysisStore';
import MemoryStore, { IMemory } from 'stores/memory/MemoryStore';
import getAnalysisContext from '../../helpers/getAnalysisContext';
import { getListConditions } from 'stores/_services/filterService';
import { buildOptions } from 'stores/_services/dataService';
import { buildCsvDownloadUrl } from 'stores/_services/downloadService';

const SEARCH_FIELDS = ['path', 'fileRepId'];

export default class MemoryListStore extends FileAnalysisStore<MemoryStore> {
    constructor() {
        super({
            itemStore: MemoryStore,
            baseRoute: 'memscans'
        });
    }

    // Analyze file isn't supported for Memory
    async analyzeFile(fileId: string): Promise<void> {
        return;
    }

    public get files(): IMemory[] {
        return this.ids.map((id) => {
            const itemStore = this.data.get(id);

            if (itemStore) {
                return {
                    ...itemStore.memory,
                    store: itemStore
                };
            }
        });
    }

    public async exportToCsv(): Promise<void> {
        const { scanId, boxId, route } = await getAnalysisContext('memscans');
        const conditions = getListConditions(this.selectedIdList, this.filter);
        conditions.push({ scanId, boxId });

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: this.sort
            },
            excludeFields: ['fileRepId', 'id', 'flagId', 'boxId']
        };

        const query = buildOptions(options);

        window.location.href = await buildCsvDownloadUrl(route, query);
    }
}
